import "@/index.css";
import BodegonNunez from "@/pages/BodegonNunez";

function App() {
  return <BodegonNunez />;
}

export default App;
